webpackJsonp([5,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _chickenGame = __webpack_require__(372);
	
	var _chickenGame2 = _interopRequireDefault(_chickenGame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shared = __webpack_require__(39);
	var Utils = __webpack_require__(25);
	
	__webpack_require__(916);
	
	$(function () {
	  Shared.init();
	  GamesChickenPage.init();
	});
	
	var GamesChickenPage = {};
	
	(function (GamesChickenPage) {
	  var game = null;
	
	  GamesChickenPage.init = function () {
	    Utils.ImageSVGToSVG();
	
	    game = (0, _chickenGame2.default)("games-chicken");
	
	    setUpCanvasScaler();
	  };
	
	  function setUpCanvasScaler() {
	    window.onload = function () {
	      resize();
	      window.addEventListener("resize", resize, false);
	    };
	  }
	
	  function resize() {
	    var $container = $("#games-chicken");
	    var canvas = $container.find("canvas").get(0);
	
	    var width = Math.min($container.width(), game.config.width);
	    var height = game.config.height / game.config.width * width;
	    var wratio = width / height;
	    var ratio = game.config.width / game.config.height;
	
	    if (wratio < ratio) {
	      canvas.style.width = width + "px";
	      canvas.style.height = width / ratio + "px";
	    } else {
	      canvas.style.width = height * ratio + "px";
	      canvas.style.height = height + "px";
	    }
	  }
	})(GamesChickenPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./fr-BE.json": 42,
		"./nl-BE.json": 43
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 37;


/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./atlas_chicken-game-0.png": 667,
		"./atlas_chicken-game-1.png": 668
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 368;


/***/ }),

/***/ 916:
907

});


// WEBPACK FOOTER //
// js/games-chicken.868f5889859906b53934.js